import React from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";

import URLToHref from "./components/URLToHref";

function Proxy({ children = null }) {
  return children;
}

export function URLMessage({ children, keywords, onKeywordClick }) {
  if (typeof children !== "string" && !(children instanceof String)) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return children
    .split(/\s+/)
    .reduce((accumulated, word, currentIndex, words) => {
      const matchedKeyword = (keywords || []).find(({ keyword: k }) => {
        return k.toLowerCase() === word.toLowerCase();
      });

      if (matchedKeyword) {
        return accumulated.concat([
          <React.Fragment key={v4()}>
            {accumulated.length > 0 ? " " : ""}
            <URLToHref {...matchedKeyword} onClick={onKeywordClick}>
              {word}
            </URLToHref>
            {currentIndex === words.length - 1 ? "" : " "}
          </React.Fragment>,
        ]);
      }

      const lastElement = accumulated[accumulated.length - 1];
      if (typeof lastElement === "string") {
        accumulated[accumulated.length - 1] += ` ${word}`;
        return accumulated;
      }

      return accumulated.concat([word]);
    }, [])
    .map((e) => {
      return <Proxy key={v4()}>{e}</Proxy>;
    });
}

URLMessage.propTypes = {
  children: PropTypes.node,
  keywords: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      params: PropTypes.string,
    })
  ),
  onKeywordClick: PropTypes.func,
};

URLMessage.defaultProps = {
  children: null,
  keywords: [],
  onKeywordClick: () => {},
};

export default URLMessage;
